import React, {useState, useEffect} from 'react'

import {
    Box,
    Stack,
    HStack,
    Modal,
    ModalBody,
    ModalHeader,
    ModalOverlay,
    ModalContent,
    ModalCloseButton
} from '@salesforce/retail-react-app/app/components/shared/ui'

import SelectedStore from './partials/selected-store'
import Header from './partials/header'
import Footer from './partials/footer'
import Search from './partials/search'
import Stores from './partials/stores'
import StoreDetails from './partials/store-details'
import {useStoreContext} from '../../contexts/store'

const SelectStoreModal = () => {
    const {isOpen, onClose, store} = useStoreContext()
    const [storeDetails, setStoreDetails] = useState(null)
    const [stores, setStores] = useState(null)
    const [editStore, setEditStore] = useState(true)
    const [hideNoSearchResults, setHideNoSearchResults] = useState(false)
    const scrollBarStyles = {
        overflowX: 'hidden',
        overflowY: 'auto',
        userSelect: 'none',
        scrollBehavior: 'smooth',
        sx: {
            '&::-webkit-scrollbar': {
                width: '2px'
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'gray.800',
                borderRadius: '2px',
                display: 'block'
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: 'gray.400',
                borderRadius: '2px',
                display: 'block'
            }
        }
    }

    const handleClose = () => {
        setEditStore(false)
        setStoreDetails(null)
        onClose()
    }

    useEffect(() => {
        if (store && store?.ID) {
            setEditStore(false)
        }
    }, [store])

    useEffect(() => {
        let localStorageStores = localStorage.getItem('savedSearchedStores')
        if (!localStorageStores) return
        try {
            localStorageStores = JSON.parse(localStorageStores)
            setStores(localStorageStores)
        } catch (e) {
            console.log(e.message)
        }
    }, [])

    if (!isOpen) {
        return null
    }

    return (
        <Modal isOpen={isOpen} onClose={handleClose}>
            <ModalOverlay />

            <ModalContent
                borderRadius="0"
                padding="20px"
                marginLeft="auto"
                minHeight={{base: '100vh', lg: 'auto'}}
                maxWidth={{base: '100%', lg: storeDetails ? '1049px' : '411px'}}
                maxHeight={{base: '100vh', lg: '616px'}}
                marginTop={{base: 'auto', lg: '56px'}}
                marginBottom={{base: 0, lg: 'auto'}}
                marginRight={{base: 'auto', lg: '20px', xl: '200px'}}
                transition="max-width 0.2s ease-in-out"
            >
                <HStack gap="0" alignItems="start" position={{base: 'relative', lg: 'static'}}>
                    {storeDetails && (
                        <Box
                            flex="1"
                            zIndex="3"
                            background="white"
                            marginY="-20px"
                            marginLeft="-20px"
                            width={{base: '100vw', lg: 'auto'}}
                            marginRight={{base: '-20px', lg: '20px'}}
                            maxHeight={{base: '100vh', lg: '616px'}}
                            position={{base: 'absolute', lg: 'static'}}
                            {...scrollBarStyles}
                        >
                            <StoreDetails
                                storeDetails={storeDetails}
                                setStoreDetails={setStoreDetails}
                            />
                        </Box>
                    )}

                    <Box width={{base: '100%', lg: '371px'}}>
                        <ModalHeader padding="0">
                            <Header editStore={editStore} />
                            <ModalCloseButton
                                color="black"
                                top={{base: 0, lg: 2}}
                                right={{base: 0, lg: 3}}
                            />
                        </ModalHeader>

                        <ModalBody paddingX="0" paddingTop="12px" paddingBottom="0">
                            {store && !editStore ? (
                                <SelectedStore
                                    setStoreDetails={setStoreDetails}
                                    setHideNoSearchResults={setHideNoSearchResults}
                                    setEditStore={setEditStore}
                                    handleClose={handleClose}
                                />
                            ) : (
                                <>
                                    <Search
                                        setStores={setStores}
                                        setHideNoSearchResults={setHideNoSearchResults}
                                    />

                                    <Stack
                                        gap="20px"
                                        maxHeight={{
                                            base: 'calc(100vh - 180px)',
                                            lg: '438px'
                                        }}
                                        marginTop="10px"
                                        marginRight="-10px"
                                        paddingRight="10px"
                                        {...scrollBarStyles}
                                    >
                                        <Stores
                                            stores={stores}
                                            setStores={setStores}
                                            hideNoSearchResults={hideNoSearchResults}
                                            setStoreDetails={setStoreDetails}
                                            setEditStore={setEditStore}
                                        />

                                        <Footer hideNoSearchResults={hideNoSearchResults} />
                                    </Stack>
                                </>
                            )}
                        </ModalBody>
                    </Box>
                </HStack>
            </ModalContent>
        </Modal>
    )
}

export default SelectStoreModal
